'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.publishSticky = exports.publish = exports.unsubscribe = exports.subscribe = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pubsubJs = require('pubsub-js');

var _pubsubJs2 = _interopRequireDefault(_pubsubJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Multiple instances of message bus can be used in applications like sportsbook.
// Due to this reason, it is required to synchronize those different instances and the only
// synchronization point available at the moment is shared dependency which is `pubsub-js`.
// Not doing the synchronization we're about to lose sticky messages between instances as well as envelopes.
// IMPORTANT: If you're about to change anything here, please take extra care to analyze and test it first!

// FIXME: Describing a key of the WeakMap to be an Object instead of EnvelopeType because of flowtype problem.
var pubSubSharedKey = '@@psmb@@';
if (!Object.prototype.hasOwnProperty.call(_pubsubJs2.default, pubSubSharedKey)) {
    Object.defineProperty(_pubsubJs2.default, pubSubSharedKey, {
        value: {
            stickyTopics: new Set(),
            topicToEnvelopesMap: new Map(),
            envelopeToConsumptionsMap: new WeakMap(),
            topicToSubscriptionsCountMap: new Map(),
            tokenToTopicMap: new Map()
        },
        enumerable: false,
        configurable: false
    });
}
var stickyTopics = _pubsubJs2.default[pubSubSharedKey].stickyTopics;
var topicToEnvelopesMap = _pubsubJs2.default[pubSubSharedKey].topicToEnvelopesMap;
var envelopeToConsumptionsMap = _pubsubJs2.default[pubSubSharedKey].envelopeToConsumptionsMap;
var topicToSubscriptionsCountMap = _pubsubJs2.default[pubSubSharedKey].topicToSubscriptionsCountMap;
var tokenToTopicMap = _pubsubJs2.default[pubSubSharedKey].tokenToTopicMap;

// eslint-disable-next-line flowtype/no-weak-types
var defaultTo = function defaultTo(value, fallback) {
    return value === undefined ? fallback : value;
};

var isTopicSticky = function isTopicSticky(topic) {
    return stickyTopics.has(topic);
};
var markTopicAsSticky = function markTopicAsSticky(topic) {
    stickyTopics.add(topic);
};
var upsertEnvelope = function upsertEnvelope(envelope) {
    var topic = envelope.topic;

    var envelopes = defaultTo(topicToEnvelopesMap.get(topic), []);
    envelopes = isTopicSticky(topic) ? [envelope] : [].concat(_toConsumableArray(envelopes), [envelope]);
    topicToEnvelopesMap.set(topic, envelopes);
    envelopeToConsumptionsMap.set(envelope, 0);
};
var getEnvelopeByTopic = function getEnvelopeByTopic(topic) {
    var envelopes = topicToEnvelopesMap.get(topic);
    return envelopes && envelopes[0];
};
var shiftEnvelopeByTopic = function shiftEnvelopeByTopic(topic) {
    var envelopes = defaultTo(topicToEnvelopesMap.get(topic), []);
    topicToEnvelopesMap.set(topic, envelopes.slice(1));
};
var increaseConsumptionsForTopic = function increaseConsumptionsForTopic(topic) {
    var envelope = defaultTo(getEnvelopeByTopic(topic), {});
    var consumptions = envelopeToConsumptionsMap.get(envelope);
    var nevValue = consumptions + 1;
    envelopeToConsumptionsMap.set(envelope, nevValue);
    return nevValue;
};
var getSubscriptionsCountByTopic = function getSubscriptionsCountByTopic(topic) {
    return defaultTo(topicToSubscriptionsCountMap.get(topic), 0);
};
var storeTopicForToken = function storeTopicForToken(token, topic) {
    tokenToTopicMap.set(token, topic);
};
var increaseSubscriptionsCountForTopic = function increaseSubscriptionsCountForTopic(topic) {
    var subscriptionsCount = getSubscriptionsCountByTopic(topic);
    topicToSubscriptionsCountMap.set(topic, subscriptionsCount + 1);
};
var decreaseSubscriptionsCountForSubscriptionToken = function decreaseSubscriptionsCountForSubscriptionToken(token) {
    var topic = defaultTo(tokenToTopicMap.get(token), '');
    var subscriptionsCount = defaultTo(topicToSubscriptionsCountMap.get(topic), 0);
    topicToSubscriptionsCountMap.set(topic, subscriptionsCount - 1);
};

//eslint-disable-next-line  no-confusing-arrow
var toMessage = function toMessage(topicOrMessage, data) {
    return typeof topicOrMessage === 'string' ? {
        topic: topicOrMessage,
        headers: {},
        data: data
    } : {
        topic: topicOrMessage.topic,
        headers: defaultTo(topicOrMessage.headers, {}),
        data: defaultTo(topicOrMessage.data, null)
    };
};

var toEnvelope = function toEnvelope(message) {
    return {
        topic: String(message.topic),
        headers: defaultTo(message.headers, {}),
        data: message.data,
        timestamp: Date.now()
    };
};

/**
 * Subscribe to specific topic on the message bus.
 * In case the targeted topic has already been published in a sticky way,
 * once the subscription is confirmed by returning a subscription token,
 * the given subscriber will be notified with data last used for specified topic name.
 * @param {string|SubscriptionType} topicOrSubscription name of the subscription topic
 * @param {Function} handler subscriber handler that will be called when a given topic is published
 * @returns {string} token unique identifier of the subscription that can be used to unsubscribe
 */
// eslint-disable-next-line  no-confusing-arrow
var subscribe = exports.subscribe = function subscribe(topicOrSubscription) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    var topic = void 0;
    var callback = void 0;
    if (typeof topicOrSubscription === 'string') {
        topic = topicOrSubscription;
        callback = handler;
    } else {
        var subscription = topicOrSubscription;
        topic = subscription.topic;
        // eslint-disable-next-line complexity
        callback = function callback(_topic, _data) {
            var envelope = getEnvelopeByTopic(subscription.topic);
            if (envelope === undefined || envelope === null) {
                envelope = toEnvelope(toMessage(_topic, _data));
                envelope.timestamp = 0;
                if (process.env.NODE_ENV !== 'production') {
                    console.warn('Message bus received an incompatible message on topic "' + _topic + '".\n' + 'It means that the message has been published by old `@wh/message-bus@1.2` instance.\n' + 'Due to this reason, the `timestamp` field has been lost.');
                }
            }
            subscription.callback(_extends({}, envelope, {
                data: defaultTo(envelope.data, null)
            }));
        };
    }

    increaseSubscriptionsCountForTopic(topic);

    // eslint-disable-next-line flowtype/require-parameter-type
    var token = _pubsubJs2.default.subscribe(topic, function () {
        callback.apply(undefined, arguments);
        if (!isTopicSticky(topic)) {
            var consumptions = increaseConsumptionsForTopic(topic);
            if (consumptions >= getSubscriptionsCountByTopic(topic)) {
                shiftEnvelopeByTopic(topic);
            }
        }
    });
    if (isTopicSticky(topic)) {
        setTimeout(function () {
            callback(topic, defaultTo(getEnvelopeByTopic(topic), {}).data);
        }, 0);
    }

    storeTopicForToken(token, topic);
    return token;
};

var unsubscribe = exports.unsubscribe = function unsubscribe(value) {
    decreaseSubscriptionsCountForSubscriptionToken(value);
    return _pubsubJs2.default.unsubscribe(value);
};

/**
 * Publish specific topic on the message bus.
 * @param {string|MessageType} topicOrMessage Name of the subscription topic
 * @param {DataType} data Payload to be carried with the published topic
 * @returns {Boolean} true If any handlers for a given topic found, false in case no action done
 */
//eslint-disable-next-line  no-confusing-arrow
var publish = exports.publish = function publish(topicOrMessage, data) {
    var envelope = toEnvelope(toMessage(topicOrMessage, data));
    var topic = envelope.topic;

    if (getSubscriptionsCountByTopic(topic) > 0 || isTopicSticky(topic)) {
        upsertEnvelope(envelope);
    }
    return _pubsubJs2.default.publish(envelope.topic, envelope.data);
};

/**
 * Publish specific topic on the message bus in a sticky way. It means that the last published data will be
 * remembered internally for any subsequent republishing.
 * @param {string} topic name of the subscription topic
 * @param {DataType} data payload to be carried with the published topic
 * @returns {Boolean} true if any handlers for a given topic found, false in case no action done
 */
var publishSticky = exports.publishSticky = function publishSticky(topic, data) {
    // Beware!
    // `publishSticky` does not support new API, so that
    // the topic has to be explicitly converted to string.
    markTopicAsSticky(String(topic));
    return publish(String(topic), data);
};
//# sourceMappingURL=messageBus.js.map